import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'accountName',
     field: FIELDS.ACCOUNT_NAME,
     title: 'Account Name',
     label: 'Account Name',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'accountType',
     field: FIELDS.ACCOUNT_TYPE,
     title: 'Account Type',
     label: 'Account Type',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'accountNo',
     field: FIELDS.ACCOUNT_NO,
     title: 'Account Number',
     label: 'Account Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'taxLine',
     field: FIELDS.TAX_LINE,
     title: 'Tax Line',
     label: 'Tax Line',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'subAccount',
     field: FIELDS.SUB_ACCOUNT,
     title: 'Sub Account',
     label: 'Sub Account',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'subAccountOf',
     field: FIELDS.SUB_ACCOUNT_OF,
     title: 'Sub AccountOf',
     label: 'Sub AccountOf',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'balance',
     field: FIELDS.BALANCE,
     title: 'Balance',
     label: 'Balance',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'total',
     field: FIELDS.TOTAL,
     title: 'Total',
     label: 'Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currency',
     field: FIELDS.CURRENCY,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'DateCreated',
     label: 'DateCreated',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
